import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "@mui/material";

const TooltipComponent = ({ children, noWrap, maxWidth, style, ...props }) => {
  const textRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const isOverflowing =
        textRef.current.scrollWidth > textRef.current.clientWidth ||
        textRef.current.scrollHeight > textRef.current.clientHeight;
      setShowTooltip(isOverflowing);
    }
  }, [children]);

  return (
    <Tooltip
      title={showTooltip ? children : ""}
      placement="bottom"
      arrow
      disableInteractive
    >
      <span
        ref={textRef}
        {...props}
        style={{
          maxWidth,
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          // cursor: showTooltip ? "pointer" : "default",
          ...style,
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};

export default TooltipComponent;
